export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const NAME_REGEX = /^[a-zA-ZÉàâéèëêïîôùüç '-]{1,30}$/;
export const ZIP_CODE_REGEX = /^[0-9]{4,5}$/;
export const CITY_REGEX = /^[A-Za-zÀ-ÿ\.'*`´’,\- "]{1,40}$/;


// WEBPACK FOOTER //
// ./src/regexes.js